import Vue from "vue";

Vue.component("chart-horizontal-bar", {
	props: ['loading', 'chartData', 'chartName'],
	data() {
		return {
			hasData: true,
			footer: ""
		};
	},
	computed: {
		chartOptions: function() {
			let self = this;
			return {
				styledMode: true,
				chart: { type: "bar", backgroundColor: "" },
				title: { text: null, align: "left", style: { fontWeight: "bold", }, },
				xAxis: {
					type: 'category',
					title: null
				},
				yAxis: {
					min: 0,
					title: '',
					labels: {
						enabled: false
					}
				},
				tooltip: {
				},
				plotOptions: {
					bar: {
						dataLabels: {
							enabled: true
						}
					}
				},
				exporting: { buttons: { contextButton: { menuItems: ["downloadPNG"] } } },
				credits: {
					enabled: false
				},
				legend: { enabled: false },
				series: self.chartData
			};
		},
	},
	template: `
		<div>
		    <wto-chart :loading="loading"
		                   :has-data="hasData"
		                   :chart-options="chartOptions"
		                   :footer="footer"></wto-chart>
		</div>
	`
});